import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const MarketingFooter = () => {
  const navigate = useNavigate();

  const handleServiceLink = (sectionId) => {
    // Navigate to services page with hash
    navigate(`/our-services#${sectionId}`);
    // Small delay then scroll to section
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <footer className="bg-white border-t border-gray-200 py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <Link 
              to="/" 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="inline-block"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_f638f114-9111-40a2-b23c-9828d06c5dac/artifacts/5m163iyk_image.png"
                alt="Fearless IT"
                className="h-10 sm:h-12 mb-4 cursor-pointer hover:opacity-80 transition-opacity"
              />
            </Link>
            <p className="text-gray-600 text-sm">
              Smart Websites. Intelligent Systems. Powerful Technology Infrastructure.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-sm sm:text-base text-black">Solutions</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link 
                  to="/services/digital"
                  className="text-gray-700 hover:text-purple-600 transition-colors"
                >
                  Digital
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/events"
                  className="text-gray-700 hover:text-purple-600 transition-colors"
                >
                  Events
                </Link>
              </li>
              <li>
                <Link 
                  to="/services/systems"
                  className="text-gray-700 hover:text-purple-600 transition-colors"
                >
                  Systems
                </Link>
              </li>
              <li>
                <Link 
                  to="/solutions/website-rescue"
                  className="text-gray-700 hover:text-purple-600 transition-colors"
                >
                  Website Rescue
                </Link>
              </li>
              <li>
                <Link 
                  to="/solutions/business-turnaround"
                  className="text-gray-700 hover:text-purple-600 transition-colors"
                >
                  Business Turnaround
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-sm sm:text-base text-black">Company</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/company/about" className="text-gray-700 hover:text-purple-600 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/company/mission" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Mission & Philosophy
                </Link>
              </li>
              <li>
                <Link to="/philanthropy" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Philanthropy
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-sm sm:text-base text-black">Resources</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/growth-audit" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Free Growth Audit
                </Link>
              </li>
              <li>
                <Link to="/resources/guides" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Guides & Playbooks
                </Link>
              </li>
              <li>
                <Link to="/our-work" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/our-pricing" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Investment
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-700 hover:text-purple-600 transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/resources/consultation" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Book Consultation
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-sm sm:text-base text-black">Legal</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/privacy-policy" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-700 hover:text-purple-600 transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 text-center text-xs sm:text-sm text-gray-600">
          © {new Date().getFullYear()} Fearless IT. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
